import React from 'react';
import { Loader2 } from 'lucide-react';

interface Props {
  size?:  'sm' | 'md' | 'lg';
  className?: string;
  fullPage?: boolean;
}

const sizeMap = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };

const LoadingSpinner: React.FC<Props> = ({ size = 'md', className = '', fullPage }) => {
  const icon = <Loader2 className={`${sizeMap[size]} animate-spin text-accent ${className}`} />;

  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        {icon}
      </div>
    );
  }
  return icon;
};

export default LoadingSpinner;
